import React, { ReactElement } from 'react';
import { Alert, ALERT_STYLE_TYPE } from 'b2b-components/theme/components/Alert';
import { ComponentType, Props } from './';
import './GlobalAlert.scss';

export const GlobalAlert: ComponentType = ({
  isLoggedIn,
  isBlocked,
  alertMessage,
}: Props): ReactElement | null => {
  if (isLoggedIn && isBlocked) {
    return (
      <div className='GlobalAlert'>
        <div className='container'>
          <Alert styleType={ALERT_STYLE_TYPE.warning}>
            {alertMessage}
          </Alert>
        </div>
      </div>
    );
  }

  return null;
};
